/**
 * Note: this controller gets called from a modal dialog, which is where the html template is defined.
 * Because of this hot reloading will not work.
 * Used in `src/app/settings/serviceGroups/serviceGroups.controller.js`
 */
import {first} from "rxjs/operators";
import {uniq, difference} from "lodash-es";
import ServiceGroupsService from "external-services/service-groups-service/serviceGroups.service";
import TrackingService from 'app/services/tracking/tracking.service';

const NS = 'EditServiceGroupCtrl';

export default function EditServiceGroupCtrl($scope, $log, $mdDialog, $timeout) {
  "ngInject";

  const vm = this;

  // states
  vm.LOADING = 1;
  vm.ENTER = 0;
  vm.SUCCESS = 2;
  vm.ERROR = 3;
  vm.TYPE_SERVICE = 'type-service';
  vm.TYPE_EVENT = 'type-event';

  vm.state = vm.LOADING; // loading state needs to go outside the fake $onInit because there is a slight delay

  //-- define public methods
  vm.cancel = cancel;
  vm.save = save;
  vm.addService = addService;
  vm.removeService = removeService;
  vm.isServiceSelectedFilter = isServiceSelectedFilter;

  /**
   * Because this controller gets added via $mdDialog, there is no default lifecycle hooks,
   * so this needs to get called from within the `onComplete` callback.
   */
  $scope.$onInit = function() {
    TrackingService.trackPageView('settings.service-group.edit');

    // arrays of objects {name:{service name}, ids:{array of service ids that match name}}
    vm.availableServices = [];
    vm.availableEvents = [];

    // array of service ids that will be compared against vm.availableServices to retrieve names
    vm.groupServices = [];

    // array of service ids that will be compared against vm.availableEvents to retrieve names
    vm.groupEvents = [];

    const hasExistingServiceGroup = !!vm.serviceGroup;
    if (!hasExistingServiceGroup) {
      vm.serviceGroup = {
        order: vm.highestOrder + 1,
        ids: [],
        isListTop: false
      };
    }

    _getServices(hasExistingServiceGroup);
  };


  function _getServices(hasExistingServiceGroup) {

    ServiceGroupsService.getAllServices()
      .pipe(first())
      .subscribe(data => {
        vm.state = vm.ENTER;

        $timeout(() => { // force UI to refresh
          vm.availableServices = data.services.slice();
          vm.availableEvents = data.events.slice();

          if (hasExistingServiceGroup) {
            _addGroupServices(vm.serviceGroup.ids, vm.TYPE_SERVICE);
            _addGroupServices(vm.serviceGroup.ids, vm.TYPE_EVENT);
          }
        });
      }, err => {
        $log.error(NS, 'serviceGroupsService.getServicesFromSchedule failed to load', err);
      });
  }


  function _addGroupServices(ids, type) {
    if (type === vm.TYPE_SERVICE) {
      const existingIds = vm.availableServices.reduce((acc, s) => (acc.concat(s.ids)), []);
      const newIds = ids.filter(id => existingIds.includes(id));
      vm.groupServices = uniq(vm.groupServices.concat(newIds));
    } else { // events
      const existingIds = vm.availableEvents.reduce((acc, s) => (acc.concat(s.ids)), []);
      const newIds = ids.filter(id => existingIds.includes(id));
      vm.groupEvents = uniq(vm.groupEvents.concat(newIds));
    }
  }

  function removeService(serviceItem, type) {
    if (type === vm.TYPE_SERVICE) {
      vm.groupServices = difference(vm.groupServices, serviceItem.ids);
    } else { // events
      vm.groupEvents = difference(vm.groupEvents, serviceItem.ids);
    }
  }

  function addService(serviceItem, type) {
    _addGroupServices(serviceItem.ids, type);
  }

  /**
   * Used in template ng-repeat filter pipe.
   * Not sure why, but the first argument is always undefined and gets passed down
   * to the nested function.
   */
  function isServiceSelectedFilter(ignoreFirstArg, type) {
    return serviceItem => _isServiceSelected(serviceItem, type);
  }

  function _isServiceSelected(serviceItem, type) {
    if (type === vm.TYPE_SERVICE) {
      return vm.groupServices.some(id => serviceItem.ids.includes(id));
    } else { // events
      return vm.groupEvents.some(id => serviceItem.ids.includes(id));
    }
  }

  function cancel() {
    $mdDialog.hide();
  }

  function save(isValid) {
    if (isValid) {
      vm.state = vm.LOADING;

      vm.serviceGroup.ids = vm.groupServices.concat(vm.groupEvents);

      ServiceGroupsService.saveServiceGroup(vm.serviceGroup)
        .pipe(first())
        .subscribe(() => {
          vm.state = vm.SUCCESS;
          $mdDialog.hide();
        }, err => {
          vm.state = vm.ENTER;
          $log.error(NS, 'Service group failed to save', err);
        });
    } else {
      vm.displayErrors = true;
    }
  }
}
